<template>
    <v-container fluid fill-height style="margin: 40px 10% 10% 10% ">
      <vueHeadful
      :title="this.$i18n.t('Menu.Acceso') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
      <v-row>
        <v-col cols="12" xs="12" md="6">
          <v-row>
            <v-col cols="12" align="center">
              <p class="letraRotada" :style="responsiveTitulo">{{$t('Formularios.Registro').toUpperCase()}}</p>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn :outlined="cliente" :text="!cliente" class="ma-2" @click="cliente = true" :color="cliente ? 'primary' : ''" :style="cliente ?'border: 2px solid' : ''">{{ $t('Formularios.Cliente') }}</v-btn>
              <v-btn :outlined="!cliente" :text="cliente" class="ma-2" @click="cliente = false" :color="!cliente ? 'primary' : ''" :style="!cliente ? 'border: 2px solid' : ''">{{ $t('Formularios.ArtistaODisenador') }}</v-btn>
            </v-col>
            <v-col cols="12">
              <v-row v-if="cliente">
                <v-form ref="form" v-model="validoClient" style="width:-webkit-fill-available!important;">
                  <v-col cols="12">
                    <v-text-field solo v-model="infoCliente.nombre" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" :rules="[v => !!v || $t('Formularios.NombreRequerido')]" persistent-hint required/>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field solo v-model="infoCliente.email" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" :rules="[v => !!v || $t('Formularios.EmailRequerido')]" persistent-hint required/>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field solo v-model="infoCliente.contrasena" :label="$t('Formularios.Contrasena')" :hint="$t('Formularios.Contrasena')" :rules="[v => !!v || $t('Formularios.CampoRequerido')]" type="password" persistent-hint required/>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox v-model="infoCliente.newsletter" :label="$t('Formularios.Newsletter')" :hint="$t('Formularios.Newsletter')" color="primary"/>
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-btn style="min-width:20%!important" color="primary white--text" x-large @click="registroCliente(infoCliente)" :disabled="!validoClient">{{ $t('Formularios.FinalizarRegistro') }}</v-btn>
                  </v-col>
                </v-form>
              </v-row>
              <v-row v-else>
                <v-col cols="12" v-if="nuevoArtista">
                    <h2>{{infoArtista.nombre}}</h2>
                    <h2 class="font-weight-light">{{infoArtista.codigo}}</h2>
                </v-col>
                <v-form ref="form" v-model="validoNew" style="width:-webkit-fill-available!important;">
                  <v-col cols="12">
                    <v-text-field solo v-model="infoArtista.email" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" :rules="[v => !!v || $t('Formularios.EmailRequerido')]" :readonly="nuevoArtista" persistent-hint />
                  </v-col>
                  <v-col cols="12" v-if="!nuevoArtista">
                    <v-text-field solo v-model="infoArtista.codigo" :label="$t('Formularios.Codigo')" :hint="$t('Formularios.Codigo')" :rules="[v => !!v || $t('Formularios.CampoRequerido')]" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center" v-if="!nuevoArtista">
                    <v-btn color="primary" x-large @click="comprobarCodigo" :loading="getCargandoAccion" :disabled="!validoNew">{{ $t('Formularios.ComprobarCodigo') }}</v-btn>
                  </v-col>
                </v-form>

                <v-col cols="12" v-if="!nuevoArtista" align="center">
                  <h3 class="font-weight-regular my-5">{{ $t('Formularios.AunNoTienesCodigo') }}</h3>
                  <v-btn outlined style="border: 2px solid;" color="primary" x-large class="mt-5" :to="$t('Alias.PorQueRegistrarse')">{{ $t('Formularios.Postulate') }}</v-btn>
                </v-col>
                <v-form autocomplete="false" v-if="nuevoArtista" v-model="valido" style="width:100%!important">
                  <v-col cols="12" v-if="nuevoArtista">
                    <v-text-field :rules="requerido" solo v-model="infoArtista.nombreDeUsuario" autocomplete="false" :label="$t('Formularios.Usuario')" :hint="$t('Formularios.HintUsuario')" persistent-hint />
                  </v-col>
                  <v-col cols="12" v-if="nuevoArtista">
                    <v-text-field :rules="requerido" solo v-model="infoArtista.contrasena" autocomplete="false" :label="$t('Formularios.Contrasena')" :hint="$t('Formularios.ContrasenaRequerido')" type="password" persistent-hint />
                  </v-col>
                  <v-col cols="12" v-if="nuevoArtista">
                    <v-autocomplete :falsees="requerido" solo :items="tiposDocumento" item-text="nombre" item-value="id" v-model="infoArtista.tipoDocumento" :label="$t('Formularios.TipoDeDocumento')" :hint="$t('Formularios.TipoDeDocumento')" persistent-hint />
                  </v-col>
                  <v-col cols="12" v-if="nuevoArtista">
                    <v-text-field :rules="requerido" solo v-model="infoArtista.documento" :label="$t('Formularios.DocumentoIdentificacion')" :hint="$t('Formularios.DocumentoIdentificacion')" persistent-hint />
                  </v-col>
                  <v-col cols="12" v-if="nuevoArtista">
                    <v-checkbox v-model="tycAceptado" :label="$t('Formularios.TyC')" @click="dialog = true" color="primary" :rules="requerido"  />
                    <v-dialog v-model="dialog" persistent max-width="50%">
                      <v-card>
                        <v-card-text>
                          <v-container>
                              <v-row>
                                  <v-col align="center" style="margin: 30px 10%;">
                                      <p v-if="getIdioma === 'es'" >{{ tyc }}</p>
                                      <p v-if="getIdioma === 'en'" >{{ tycEn }}</p>
                                      <br>
                                      <v-btn href="https://trartist.com/tyc" target="_blank" color="black white--text">{{ $t('Acceso.TerminosYcondiciones')}}</v-btn>
                                      <!-- <v-btn @click="dialogTyC = true" color="black white--text">{{ $t('Acceso.TerminosYcondiciones')}}</v-btn>
                                      <br>
                                      <div class="textoMagazine" v-html="terminosEs" v-if="dialogTyC && getIdioma === 'es'" />
                                      <div class="textoMagazine" v-html="terminosEn" v-if="dialogTyC && getIdioma === 'en'" />
                                      <v-btn v-if="dialogTyC" @click="dialogTyC = false" color="black white--text">{{ $t('Formularios.Cerrar')}}</v-btn> -->
                                  </v-col>
                              </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="black white--text" style="border: 2px solid" class="ma-3" large @click.native="noAcepto">{{ $t('Formularios.NoAcepto')}}</v-btn>
                          <v-btn color="black white--text" style="border: 2px solid" class="ma-3" large @click.native="siAcepto">{{ $t('Formularios.Acepto')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" v-if="nuevoArtista" align="center">
                    <v-btn color="black white--text" x-large @click="comprobacion" :disabled="!valido" class="mt-5" :loading="getCargandoAccion">{{ $t('Formularios.FinalizarRegistro') }}</v-btn>
                  </v-col>
                </v-form>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xs="12" md="6">
          <v-row>
            <v-col cols="12" align="center" :style="espaciado">
              <span class="letraRotada" :style="responsiveTitulo">{{$t('Formularios.Acceso').toUpperCase()}}</span>
            </v-col>
            <v-form ref="form" v-model="validoLogin" style="width:-webkit-fill-available!important;">

              <v-col cols="12">
                <v-text-field solo v-model="infoLogin.email" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" :rules="[v => !!v || $t('Formularios.EmailRequerido')]" required persistent-hint />
              </v-col>
              <v-col cols="12">
                <v-text-field solo v-model="infoLogin.contrasena" v-on:keyup.enter="iniciarSesion(infoLogin)" :label="$t('Formularios.Contrasena')" :hint="$t('Formularios.Contrasena')" type="password" :rules="[v => !!v || $t('Formularios.ContrasenaRequerido')]" required persistent-hint />
              </v-col>
              <v-col cols="12" align="center">
                <v-btn style="min-width:20%!important" color="primary white--text" x-large @click="iniciarSesion(infoLogin)" :disabled="!validoLogin">{{ $t('Formularios.IniciarSesion') }}</v-btn>
              </v-col>
            </v-form>
            <v-col cols="12" align="center">
              <v-btn text @click="contrasenaOlvidada">{{ $t('Formularios.OlvidasteContrasena') }}</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'acceso',
  data () {
    return {
      usuario: [],
      cliente: true,
      nuevoArtista: false,
      infoCliente: {
        nombre: null,
        email: null,
        contrasena: null,
        newsletter: true,
        favoritos: []
      },
      infoLogin: {
        email: null,
        contrasena: null
      },
      infoArtista: {
        aprobado: false,
        nombre: null,
        pseudonimo: null,
        biografia: null,
        pais: null,
        departamento: null,
        ciudad: null,
        direccion: null,
        email: null,
        telefono: null,
        redesSociales: null,
        contrasena: null,
        codigo: null,
        nombreRefPersonal: null,
        emailRefPersonal: null,
        telefonoRefPersonal: null,
        nombreRefProfesional: null,
        emailRefProfesional: null,
        telefonoRefProfesional: null,
        tipoDocumento: null,
        numeroDocumento: null,
        categoria: null,
        nombreDeUsuario: null,
        favoritos: []
      },
      tyc: '',
      tycEn: '',
      terminosEs: '',
      terminosEn: '',
      nombresDeUsuario: [],
      tycAceptado: false,
      dialog: false,
      dialogTyC: false,
      TiposDePago: [
        {
          id: 'banco',
          nombre: this.$i18n.t('Formularios.ConsignacionBancaria')
        },
        {
          id: 'paypal',
          nombre: this.$i18n.t('Formularios.Paypal')
        }
      ],
      tiposDocumento: [
        {
          id: 'CC',
          nombre: this.$i18n.t('Formularios.CedulaCiudadania')
        },
        {
          id: 'TI',
          nombre: this.$i18n.t('Formularios.TarjetaIdentidad')
        },
        {
          id: 'CE',
          nombre: this.$i18n.t('Formularios.CedulaExtranjeria')
        }
      ],
      valido: false,
      requerido: [v => !!v || this.$i18n.t('Formularios.CampoRequerido')],
      confirmarContrasena: null,
      validoClient: false,
      validoNew: false,
      validoLogin: false
    }
  },
  methods: {
    ...mapActions(['iniciarSesion', 'registroCliente', 'registroArtista', 'recuperarContrasena', 'registroArtistaUpdate']),
    ...mapMutations(['setAlerta', 'setTextoAlerta', 'setCargandoAccion']),
    comprobarCodigo () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('postulaciones').doc(this.infoArtista.codigo).get().then(info => {
        if (info.data().email === this.infoArtista.email) {
          if (info.data().revisado && info.data().aprobado) {
            this.nuevoArtista = true
            this.infoArtista.aprobado = false
            this.infoArtista.nombre = info.data().nombre
            this.infoArtista.pseudonimo = info.data().pseudonimo
            this.infoArtista.biografiaEs = info.data().biografiaEs
            this.infoArtista.pais = info.data().pais
            this.infoArtista.departamento = info.data().departamento
            this.infoArtista.ciudad = info.data().ciudad
            this.infoArtista.direccion = info.data().direccion
            this.infoArtista.email = info.data().email
            this.infoArtista.nombre = info.data().nombre
            this.infoArtista.nombreRefPersonal = info.data().nombreRefPersonal
            this.infoArtista.emailRefPersonal = info.data().emailRefPersonal
            this.infoArtista.telefonoRefPersonal = info.data().telefonoRefPersonal
            this.infoArtista.nombreRefProfesional = info.data().nombreRefProfesional
            this.infoArtista.emailRefProfesional = info.data().emailRefProfesional
            this.infoArtista.telefonoRefProfesional = info.data().telefonoRefProfesional
            this.infoArtista.telefono = info.data().telefono
            this.infoArtista.categoria = info.data().categoria
            this.infoArtista.redesSociales = info.data().redesSociales
            this.setCargandoAccion(false)
          } else if (info.data().revisado && !info.data().aprobado) {
            this.setAlerta()
            this.setTextoAlerta('Alerta.Rechazado')
            this.setCargandoAccion(false)
          } else {
            this.setAlerta()
            this.setTextoAlerta('Alerta.NoAprobado')
            this.setCargandoAccion(false)
          }
        } else {
          this.setAlerta()
          this.setTextoAlerta('Alerta.NoCoincide')
          this.setCargandoAccion(false)
        }
      })
        .catch(error => {
          console.log(error)
          this.setAlerta()
          this.setTextoAlerta('Alerta.CodigoIncorrecto')
          this.setCargandoAccion(false)
        })
    },
    siAcepto () {
      if (!this.tycAceptado) {
        this.tycAceptado = true
      }
      this.dialog = false
    },
    noAcepto () {
      if (this.tycAceptado) {
        this.tycAceptado = false
      }
      this.dialog = false
    },
    async comprobacion () {
      await firebase.firestore().collection('usuarios').get().then(info => {
        for (let i = 0; i < info.docs.length; i++) {
          this.usuario.push(info.docs[i].data())
          this.setCargandoAccion(true)
          var cont = this.nombresDeUsuario.length
          for (let i = 0; i < this.nombresDeUsuario.length; i++) {
            if (this.nombresDeUsuario[i] === this.infoArtista.nombreDeUsuario) {
              this.setAlerta()
              this.setTextoAlerta('Alerta.NombreEnUso')
              this.setCargandoAccion(false)
              break
            }
          }
        }
        cont = cont - 1
        if (cont === 0) {
          this.usuario = []
          this.addUser()
        }
      })
    },
    async addUser () {
      await firebase.firestore().collection('usuarios').where('email', '==', this.infoArtista.email).get().then(info => {
        for (let i = 0; i < info.docs.length; i++) {
          this.usuario.push(info.docs[i].data())
        }
      })
      if (this.usuario.length === 0) {
        this.registroArtista(this.infoArtista)
        // console.log('entra 1')
      } else {
        this.registroArtistaUpdate(this.infoArtista)
        // console.log('entra 2')
      }
    },
    contrasenaOlvidada () {
      if (this.infoLogin.email) {
        this.recuperarContrasena(this.infoLogin.email)
      } else {
        this.setAlerta()
        this.setTextoAlerta('Alerta.IntroduceEmail')
      }
    }
  },
  computed: {
    ...mapGetters(['getPaises', 'getTipoRedes', 'getRol', 'getCargandoAccion', 'getIdioma', 'getTotal']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    },
    espaciado () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return ''
        case 'sm': return ''
        case 'md': return 'margin-bottom:100px'
        case 'lg': return 'margin-bottom:100px'
        case 'xl': return 'margin-bottom:100px'
        default: return 'margin-bottom:100px'
      }
    }
  },
  async mounted () {
    if (this.getRol !== 'invitado') {
      this.$router.push('/')
    }
    firebase.firestore().collection('utilidades').doc('legal').get().then(info => {
      this.tyc = info.data().textoArtista
      this.tycEn = info.data().textoArtistaEn
    })
    firebase.firestore().collection('utilidades').doc('tyc').get().then(info => {
      this.terminosEs = info.data().descripcionEs
      this.terminosEn = info.data().descripcionEn
    })
    firebase.firestore().collection('utilidades').doc('nombresDeUsuario').get().then(info => {
      this.nombresDeUsuario = info.data().nombresDeUsuario
    })
  }
}
</script>

<style scoped>
.letraRotada {
  font-weight: 600;
  letter-spacing: 10px;
  color: #26A69A;
  font-family: 'Be Vietnam', sans-serif!important;
}
</style>
